import { getWorkoutSessionsState } from 'src/utils/workSessions.utils';
import { WorkSessionsState } from 'src/models/workSessions';

const initialState: WorkSessionsState = getWorkoutSessionsState();

export default initialState;
